export default __webpack_public_path__ + "static/media/spade.af4fdfea.webp";